module.exports = __webpack_public_path__ + "img/driver_bz.e96df378.png";